import React from "react";
import { useWatch } from "react-hook-form";
import { Divider, GridLegacy, List, ListItem } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { Link } from "react-router";
import Tooltip from "@mui/material/Tooltip";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Button from "../../../components/CustomButtons/Button";
import Edit from "@mui/icons-material/Edit";

export default function ChildUsers() {
  const childUsers = useWatch({ name: "child_users" });

  return (
    <Card style={{ maxWidth: 900 }}>
      <CardBody style={{ padding: 16 }}>
        <List>
          <ListItem style={{ flexDirection: "column", fontWeight: 800 }}>
            <GridLegacy alignItems={"center"} container>
              <GridLegacy item xs={2}>
                <TranslationWrapper tDefault={"#"} tKey={"ChildUsers.id"} />
              </GridLegacy>
              <GridLegacy item xs={6}>
                <TranslationWrapper tDefault={"E-mail address"} tKey={"ChildUsers.email"} />
              </GridLegacy>
              <GridLegacy item xs={2}>
                <TranslationWrapper tDefault={"Profile"} tKey={"ChildUsers.profile"} />
              </GridLegacy>
              <GridLegacy />
            </GridLegacy>
            <Divider style={{ width: "100%" }} />
          </ListItem>
          {childUsers?.map((childUser) => {
            return (
              <ListItem style={{ flexDirection: "column" }}>
                <GridLegacy alignItems={"center"} container>
                  <GridLegacy item xs={2}>
                    {childUser.id}
                  </GridLegacy>
                  <GridLegacy item xs={6}>
                    {childUser.email}
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    {childUser.profile?.name}
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <Link to={`/manager/gebruikers/${childUser.id}/edit`}>
                      <Tooltip
                        classes={{}}
                        placement={"bottom"}
                        title={<TranslationWrapper tDefault={"Open user"} tKey={"global.jamezzTable.viewUser"} />}
                      >
                        <Button color={"success"} simple>
                          <Edit />
                        </Button>
                      </Tooltip>
                    </Link>
                  </GridLegacy>
                </GridLegacy>
                <Divider style={{ width: "100%" }} />
              </ListItem>
            );
          })}
        </List>
      </CardBody>
    </Card>
  );
}
